import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/sugarcastle/images/logos/logo.png';

export default function index() {
  return <Image src={footerLogo} minW={['200px', null, '300px']} mt="3" />;
}
